module.exports = __webpack_public_path__ + "img/grade-6.1c8901fd.png";